import { render, staticRenderFns } from "./VideoCardSummary.vue?vue&type=template&id=555ab5d0&"
import script from "./VideoCardSummary.vue?vue&type=script&lang=ts&"
export * from "./VideoCardSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports